import LayoutMain from './../../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../../ProgressHUD/index.vue'
import GoogleMap from './../../../GoogleMap/VueGoogleMap.vue'
import { Api, Toast, Helper } from './../../../../services'

import VueCropper from 'vue-cropper'

export default {
  name: 'ProjectCrowfundingEdit',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    VueCropper,
    GoogleMap,
  },
  data() {
    return {
      project: {
        name: '',
        description: '',
        goal: '',
        country: '',
        user: '', // it's user id
        address: '',
        projectAddress: '',
        businessAddress: '',
        images: [],
        latitude: null,
        longitude: null,
        type: '',
        structure: '',
        competitor: '',
        customer: '',
        industry: '',
        threatCompetitor: false,
        powerSupplier: false,
        powerCustomer: false,
        rivalry: false,
        income: '',
        offerPublic: '',
        type: '',
        businessPlan: {
          definition: '',
          marketPlan1: '',
          operation: '',
          marketPlan2: '',
          pci: '',
          financial: '',
        },
        draft: false,
      },
      ndaFile: null,
      validationMessage: '',
      displayFirstPage: true,
      types: {
        0: 'Solar',
        1: 'Concentration Solar',
        2: 'Wind',
        3: 'Biogas',
        4: 'Wood Gasification',
        5: 'Gasification of Organics',
        6: 'Waste Gasification',
        7: 'Hydroelectric',
        8: 'Undumotor',
      },
      prjData: [],
      income: 2,
      incomeString: ['Low', 'Medium', 'High'],
      offerPublic: 0,
      offerPublicString: ['Sale of Equity', 'Oreder of Loan'],
      offerPublicOther: '',
      option: {
        img: null,
        size: 1,
        outputType: 'png',
        res: '',
        w: 1200,
        h: 400,
      },
      draft: false,
    }
  },
  methods: {
    setHeightImage() {
      var pic_box = $('.picture-box')
      if (pic_box && pic_box[0]) {
        var h = document.getElementById('content').clientHeight
        pic_box[0].style.height =
          (h > screen.availHeight ? h - 80 : screen.availHeight - 80) + 'px'
      }
    },

    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize(event) {
      this.setHeightImage()
    },

    async saveProject() {
      try {
        const isValid = await this.$validator.validateAll('firstForm')
        if (!isValid) {
          Toast.validationFieldsError({ toast: this.$toast })
          return
        }

        this.$refs.progress.show()

        this.project.latitude = this.$refs.googleMap.marker.position.lat()
        this.project.longitude = this.$refs.googleMap.marker.position.lng()

        this.project.country = this.$refs.selectCountry.value
        this.project.type = this.$refs.selectType.value

        this.project.income = this.incomeString[this.income]
        this.project.offerPublic =
          this.offerPublic == 2
            ? this.offerPublicOther
            : this.offerPublicString[this.offerPublic]
        this.project.user = this.$localStorage.get('userid')
        this.project.businessPlan = JSON.stringify(this.project.businessPlan)

        this.project.threatCompetitor = this.$refs.threatCompetitor.checked
        this.project.powerSupplier = this.$refs.powerSupplier.checked
        this.project.powerCustomer = this.$refs.powerCustomer.checked
        this.project.rivalry = this.$refs.rivalry.checked

        var formData = new FormData()
        formData.append('id', this.$route.params.id)

        let image = await this.cropIt()
        formData.append('files0', image)

        if (this.ndaFile) {
          formData.append('ndaFile0', this.ndaFile)
        }

        for (var key in this.project) {
          formData.append(key, this.project[key])
        }

        var response = await Api.editProject(formData)

        this.$router.push(
          '/project/systemsdetail/crowdfunding/' + response.data.project._id
        )
      } catch (error) {
        var message = 'Something went wrong.'
        if (error.message) {
          message = error.message
        }

        this.validationMessage = message
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: message,
        })
      } finally {
        this.$refs.progress.hide()
      }
    },

    async getProject() {
      try {
        var response = await Api.getSystemsDetailById(this.$route.params.id)
        var resultDate = response.data.results[0]

        this.project.name = resultDate.project.name
        this.project.description = resultDate.project.description
        this.project.goal = resultDate.project.goal
        this.project.country = resultDate.project.country
        this.project.user = resultDate.project.user
        this.project.address = resultDate.project.address
        this.project.projectAddress = resultDate.project.projectAddress
        this.project.businessAddress = resultDate.project.businessAddress
        this.project.latitude = resultDate.project.latitude
        this.project.longitude = resultDate.project.longitude
        this.project.type = resultDate.project.type
        this.project.structure = resultDate.project.structure
        this.project.competitor = resultDate.project.competitor
        this.project.customer = resultDate.project.customer
        this.project.industry = resultDate.project.industry
        this.project.threatCompetitor = resultDate.project.threatCompetitor
        this.project.powerSupplier = resultDate.project.powerSupplier
        this.project.powerCustomer = resultDate.project.powerCustomer
        this.project.rivalry = resultDate.project.rivalry
        this.project.draft = resultDate.project.draft

        this.project.income = resultDate.project.income
        this.income = this.incomeString.indexOf(resultDate.project.income)

        this.project.offerPublic = resultDate.project.offerPublic
        var offerPublicindexOf = this.offerPublicString.indexOf(
          resultDate.project.offerPublic
        )
        this.offerPublic = offerPublicindexOf == -1 ? 2 : offerPublicindexOf
        if (this.offerPublic == 2) {
          this.offerPublicOther = resultDate.project.offerPublic
        }

        this.project.type = resultDate.project.type
        this.project.businessPlan = JSON.parse(resultDate.project.businessPlan)

        if (
          this.project.businessPlan == undefined ||
          this.project.businessPlan == null
        ) {
          this.project.businessPlan = {
            definition: '',
            marketPlan1: '',
            operation: '',
            marketPlan2: '',
            pci: '',
            financial: '',
          }
        } else {
          if (this.project.businessPlan.definition == undefined) {
            this.project.businessPlan.definition = ''
          }
          if (this.project.businessPlan.marketPlan1 == undefined) {
            this.project.businessPlan.marketPlan1 = ''
          }
          if (this.project.businessPlan.operation == undefined) {
            this.project.businessPlan.operation = ''
          }
          if (this.project.businessPlan.marketPlan2 == undefined) {
            this.project.businessPlan.marketPlan2 = ''
          }
          if (this.project.businessPlan.pci == undefined) {
            this.project.businessPlan.pci = ''
          }
          if (this.project.businessPlan.financial == undefined) {
            this.project.businessPlan.financial = ''
          }
        }

        await new Promise(resolve => this.$nextTick(resolve))

        this.$refs.googleMap.setPosition(
          this.project.latitude,
          this.project.longitude
        )

        this.$refs.selectCountry.value = this.project.country
        this.$refs.selectType.value = this.project.type

        var indexOfferPublic = this.offerPublicString.indexOf(
          this.project.offerPublic
        )
        if (indexOfferPublic >= 0) {
          this.offerPublic == indexOfferPublic
        } else {
          this.offerPublic == 0
        }

        this.$refs.threatCompetitor.checked = this.project.threatCompetitor
        this.$refs.threatCompetitorNo.checked = !this.project.threatCompetitor

        this.$refs.powerSupplier.checked = this.project.powerSupplier
        this.$refs.powerSupplierNo.checked = !this.project.powerSupplier

        this.$refs.powerCustomer.checked = this.project.powerCustomer
        this.$refs.powerCustomerNo.checked = !this.project.powerCustomer

        this.$refs.rivalry.checked = this.project.rivalry
        this.$refs.rivalryNo.checked = !this.project.rivalry

        this.option.img = resultDate.project.images[0]
      } catch (error) {
        console.error(error)
        this.validationMessage = error.message

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {
        this.$refs.progress.hide()
      }
    },

    checked(firstEl, secEl) {
      $(secEl).prop('checked', !$(firstEl).is(':checked'))
    },

    onNdaFileChange(event) {
      var files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        this.ndaFile = files[0]
      }
    },

    onFileChange(event) {
      var files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        var reader = new FileReader()
        let _self = this
        reader.onload = e => {
          var img = new Image()
          img.onload = function() {
            _self.option.w = img.width / (img.height / 400)
          }
          img.src = reader.result
          _self.option.img = e.target.result
        }
        reader.readAsDataURL(files[0])
      }
    },

    cropIt() {
      return new Promise((resolve, reject) => {
        if (this.$refs.cropper.imgs == '') {
          reject({ message: 'Please upload the image' })
          return
        }

        this.$refs.cropper.startCrop()
        this.$refs.cropper.getCropData(image => {
          console.log(image)
          fetch(image)
            .then(res => res.blob())
            .then(blob => {
              const file = new File([blob], 'image.png')
              resolve(file)
            })
            .catch(error => {
              reject(error)
            })
        })
      })
    },
  },
  async created() {
    this.countries = require('./../../../../data/country.js')

    await this.getProject()

    this.$nextTick(function() {
      Materialize.updateTextFields()
      $('select').material_select()
    })
  },
  async mounted() {
    this.setHeightImage()
    window.addEventListener('resize', this.handleResize)
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/SystemsDetail/ProjectCrowdfundingEdit/ProjectCrowdfundingEdit.component.js